import type { QueryClient } from '@tanstack/react-query';
import { getMutationKey, getQueryKey } from '@trpc/react-query';
import { trpcProcedures } from '../generated/trpc-spec.gen';
import { api } from '../trpc/client';

// INFO: Set up query defaults after api is available to avoid circular deps
export const setupQueryDefaults = (qc: QueryClient) => {
	Object.entries(trpcProcedures).forEach(([key, config]) => {
		switch (config.type) {
			case 'query': {
				// @ts-expect-error route must be typed
				const queryKey = getQueryKey(api[key]);
				config.meta.queries &&
					qc.setQueryDefaults(queryKey, config.meta.queries);
				break;
			}
			case 'mutation': {
				// @ts-expect-error route must be typed
				const mutationKey = getMutationKey(api[key]);
				config.meta.mutations &&
					qc.setMutationDefaults(mutationKey, config.meta.mutations);
				break;
			}
			default:
				break;
		}
	});
};
